module.exports = ".organization-type-form {\n  width: 300px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/addeditorganisation-type/addeditorganisation-type.component.scss
// module id = ./src/app/component/addeditorganisation-type/addeditorganisation-type.component.scss
// module chunks = main